import { render, staticRenderFns } from "./EduButton.vue?vue&type=template&id=52a9cbc2&scoped=true"
import script from "./EduButton.vue?vue&type=script&lang=js"
export * from "./EduButton.vue?vue&type=script&lang=js"
import style0 from "./EduButton.vue?vue&type=style&index=0&id=52a9cbc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a9cbc2",
  null
  
)

export default component.exports